// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewGatePassModal_backdrop__VmKCd {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
}

.ViewGatePassModal_modal__Bb-eF {
  width: min(820px, 92vw);
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 20px 60px rgba(0,0,0,0.15);
  overflow: hidden;
}

.ViewGatePassModal_header__VFejy {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #E5E7EB
  

}

.ViewGatePassModal_title__sHw1t {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
}

.ViewGatePassModal_closeBtn__YpKKf {
  appearance: none;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 8px;
  margin: -8px;
}

.ViewGatePassModal_closeIcon__uqpaH {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 20px;
  color: #6B7280;
}

.ViewGatePassModal_content__ZjN3E {
  padding: 20px 24px 28px;
}

.ViewGatePassModal_row__ehcxb {
  display: grid;
  grid-template-columns: 160px 1fr 120px 1fr;
  gap: 12px 24px;
  align-items: center;
  padding: 9px 0;
}



.ViewGatePassModal_colLabel__RMnGX {
  grid-column: span 1;
  color: var(--Neutral-500, #737373);

/* Inter/Body small/Body small - regular */
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 20px; /* 142.857% */
}

.ViewGatePassModal_colValue__tjQXH {
  grid-column: span 1;
  overflow: hidden;
color: var(--Slate-800, #1E293B);
text-overflow: ellipsis;

/* Inter/Body small/Body small - medium */
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 20px; /* 142.857% */
}

/* When a row has only two columns (label + value) */
.ViewGatePassModal_row__ehcxb:nth-child(n+2) .ViewGatePassModal_colLabel__RMnGX:first-child ~ .ViewGatePassModal_colValue__tjQXH:only-child {
  grid-column: 2 / 5;
}

.ViewGatePassModal_statusPill__-6kGs {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.ViewGatePassModal_statusPending__V6MKm {
  background: #FEF3C7;
  color: #92400E;
}

.ViewGatePassModal_statusApproved__Fq2Tu {
  background: #DCFCE7;
  color: #065F46;
}

.ViewGatePassModal_statusRejected__-DKZJ {
  background: #FEE2E2;
  color: #991B1B;
}

.ViewGatePassModal_statusDefault__dfOtI {
  background: #E5E7EB;
  color: #374151;
}

.ViewGatePassModal_dateText__0cYQ7 {
  margin-right: 16px;
  font-weight: 700;
}

.ViewGatePassModal_timeText__IgcTs {
  color: #9CA3AF;
}
.ViewGatePassModal_timelineButton__Ajz9o:hover {
  background: #111827;
  color: var(--White, #FFF);
  box-shadow: 0 4px 12px rgba(2, 6, 23, 0.25);
  transform: translateY(-1px);
}

@media (max-width: 640px) {
  .ViewGatePassModal_row__ehcxb {
    grid-template-columns: 140px 1fr;
  }
  .ViewGatePassModal_row__ehcxb .ViewGatePassModal_colLabel__RMnGX:nth-of-type(2),
  .ViewGatePassModal_row__ehcxb .ViewGatePassModal_colValue__tjQXH:nth-of-type(2) {
    grid-column: auto;
  }
}


`, "",{"version":3,"sources":["webpack://./src/views/StudentGatePass/components/ViewGatePassModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB;;;AAGF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;;;AAIA;EACE,mBAAmB;EACnB,kCAAkC;;AAEpC,0CAA0C;AAC1C,kBAAkB;AAClB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,aAAa;AAChC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB,gCAAgC;AAChC,uBAAuB;;AAEvB,yCAAyC;AACzC,kBAAkB;AAClB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,aAAa;AAChC;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE;IACE,gCAAgC;EAClC;EACA;;IAEE,iBAAiB;EACnB;AACF","sourcesContent":[".backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1300;\n}\n\n.modal {\n  width: min(820px, 92vw);\n  border-radius: 16px;\n  background: #ffffff;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.15);\n  overflow: hidden;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #E5E7EB\n  \n\n}\n\n.title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.closeBtn {\n  appearance: none;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  padding: 8px;\n  margin: -8px;\n}\n\n.closeIcon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n  text-align: center;\n  font-size: 20px;\n  color: #6B7280;\n}\n\n.content {\n  padding: 20px 24px 28px;\n}\n\n.row {\n  display: grid;\n  grid-template-columns: 160px 1fr 120px 1fr;\n  gap: 12px 24px;\n  align-items: center;\n  padding: 9px 0;\n}\n\n\n\n.colLabel {\n  grid-column: span 1;\n  color: var(--Neutral-500, #737373);\n\n/* Inter/Body small/Body small - regular */\nfont-family: Inter;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 20px; /* 142.857% */\n}\n\n.colValue {\n  grid-column: span 1;\n  overflow: hidden;\ncolor: var(--Slate-800, #1E293B);\ntext-overflow: ellipsis;\n\n/* Inter/Body small/Body small - medium */\nfont-family: Inter;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 20px; /* 142.857% */\n}\n\n/* When a row has only two columns (label + value) */\n.row:nth-child(n+2) .colLabel:first-child ~ .colValue:only-child {\n  grid-column: 2 / 5;\n}\n\n.statusPill {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.statusPending {\n  background: #FEF3C7;\n  color: #92400E;\n}\n\n.statusApproved {\n  background: #DCFCE7;\n  color: #065F46;\n}\n\n.statusRejected {\n  background: #FEE2E2;\n  color: #991B1B;\n}\n\n.statusDefault {\n  background: #E5E7EB;\n  color: #374151;\n}\n\n.dateText {\n  margin-right: 16px;\n  font-weight: 700;\n}\n\n.timeText {\n  color: #9CA3AF;\n}\n.timelineButton:hover {\n  background: #111827;\n  color: var(--White, #FFF);\n  box-shadow: 0 4px 12px rgba(2, 6, 23, 0.25);\n  transform: translateY(-1px);\n}\n\n@media (max-width: 640px) {\n  .row {\n    grid-template-columns: 140px 1fr;\n  }\n  .row .colLabel:nth-of-type(2),\n  .row .colValue:nth-of-type(2) {\n    grid-column: auto;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `ViewGatePassModal_backdrop__VmKCd`,
	"modal": `ViewGatePassModal_modal__Bb-eF`,
	"header": `ViewGatePassModal_header__VFejy`,
	"title": `ViewGatePassModal_title__sHw1t`,
	"closeBtn": `ViewGatePassModal_closeBtn__YpKKf`,
	"closeIcon": `ViewGatePassModal_closeIcon__uqpaH`,
	"content": `ViewGatePassModal_content__ZjN3E`,
	"row": `ViewGatePassModal_row__ehcxb`,
	"colLabel": `ViewGatePassModal_colLabel__RMnGX`,
	"colValue": `ViewGatePassModal_colValue__tjQXH`,
	"statusPill": `ViewGatePassModal_statusPill__-6kGs`,
	"statusPending": `ViewGatePassModal_statusPending__V6MKm`,
	"statusApproved": `ViewGatePassModal_statusApproved__Fq2Tu`,
	"statusRejected": `ViewGatePassModal_statusRejected__-DKZJ`,
	"statusDefault": `ViewGatePassModal_statusDefault__dfOtI`,
	"dateText": `ViewGatePassModal_dateText__0cYQ7`,
	"timeText": `ViewGatePassModal_timeText__IgcTs`,
	"timelineButton": `ViewGatePassModal_timelineButton__Ajz9o`
};
export default ___CSS_LOADER_EXPORT___;
